import { render, staticRenderFns } from "./RequestTrainingList.vue?vue&type=template&id=01f127d4&"
import script from "./RequestTrainingList.vue?vue&type=script&lang=js&"
export * from "./RequestTrainingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports